{
  "search": "Buscar",
  "login": "Identificador",
  "firstname": "Nombre",
  "lastname": "Apellidos",
  "email": "E-mail",
  "addUserGroup": "Añadir un grupo",
  "selectUserProfile": "Seleccionar un perfil",
  "profile": "Perfil",
  "userProfile": "Perfil de usuario",
  "language": "Idioma",
  "label": "Apellidos",
  "error": {
    "required": "Campo obligatorio",
    "maxLength": "Longitud máx.: {maxLength}",
    "invalidFormat": "Formato no válido",
    "lowercaseOnly": "Solo minúsculas"
  },
  "url": "URL",
  "deleteFile": "Haga clic para eliminar el archivo",
  "password": "Contraseña",
  "nominalTemplateName": "Nombre de la plantilla nominal",
  "bootstrapTemplateName": "Nombre de la plantilla bootstrap",
  "secondIntervalTime": "Tiempo de intervalo (segundos)",
  "profileName": "Nombre del perfil",
  "languages": {
    "en": "Inglés (English)",
    "fr": "Francés (Français)",
    "it": "Italiano",
    "es": "Español"
  },
  "passwordPlaceholder": "**********",
  "clickToUpload": "Haga clic para importar",
  "orDragAndDrop": "o arrastre-suelte un archivo con el formato {format}",
  "orDragAndDropWithoutExtension": "\no arrastre-suelte",
  "information": {
    "more": "Ver más información"
  },
  "select": {
    "search": {
      "placeholder": "Buscar",
      "noResults": "No hay resultados."
    }
  },
  "timezone": {
    "placeholder": "Seleccionar zona horaria"
  },
  "selectAll": "Seleccionar todo",
  "optional": "Opcional"
}
